import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerNecesitoTurno = styled(motion.div)`
  width: 100%;
  height: 88vh;
  height: 88dvh;

  /* @media (min-width: 768px) and (max-width: 1199px) {
    height: 100vh;
    height: 100dvh;
  } */
  /* @media (min-width: 1200px) {
    height: 100vh;
    height: 100dvh;
  } */
`;

export const TextNecesitoTurno = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 15%;
  margin-top: 20px;
  .title-saludo {
    text-align: center;
    font-family: Rubik;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 30px */
    width: 320px;
  }
  .title-pregunta {
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
  .title-negrita {
    font-size: ${({$isTerminal}) => $isTerminal ? "24px" : "20px"};
    /* font-weight: bold; */
  }
`;

export const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  height: calc(100% - 264px);
  overflow-y: auto;
  padding: 0px 0px 20px 0;
  svg {
    width: 25px;
    height: 25px;
  }
  /* Tablet: 2 columnas */
  @media (min-width: 768px) and (max-width: 1199px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    padding: 20px;
    height: calc(100% - 234px);
  }
  /* Desktop: 2 columnas */
  @media (min-width: 1200px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 28px;
    padding: 40px;
  }
`;

export const ButtonContainer = styled(motion.div)`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const BuscadorBox = styled.div`
  display: none;
`;

export const BtnBuscarTurnos = styled.button`
  display: flex;
  justify-content: center;
  padding: 10px;
  border-radius: 8px;
  background: var(--colors-dim-1-active, #f60);
  box-shadow:
    0px 2.49716px 1.99772px 0px rgba(0, 0, 0, 0.02),
    0px 6.00101px 4.80081px 0px rgba(0, 0, 0, 0.03),
    0px 11.29937px 9.0395px 0px rgba(0, 0, 0, 0.04),
    0px 20.15615px 16.12492px 0px rgba(0, 0, 0, 0.04),
    0px 37.69987px 30.1599px 0px rgba(0, 0, 0, 0.05),
    0px 90.23941px 72.19153px 0px rgba(0, 0, 0, 0.07);
  text-align: center;
  font-family: Rubik;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`;
